import { useEffect, useRef, useState } from 'react';
import { busTrees } from '../data/beheer/system';
import type { BusMessage } from '../types/beheer';

const MAX = 80;

function clock(): string {
  const d = new Date();
  const p = (n: number, l = 2) => String(n).padStart(l, '0');
  return `${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}.${p(d.getMilliseconds(), 3)}`;
}

/** Simulated live MQTT stream across all topic trees. Pausing freezes the view, not the counts. */
export function useBusFeed(paused: boolean) {
  const [messages, setMessages] = useState<BusMessage[]>([]);
  const [counts, setCounts] = useState<Record<string, number>>({});
  const seq = useRef(0);
  const pausedRef = useRef(paused);
  pausedRef.current = paused;

  useEffect(() => {
    let timer = 0;
    const tick = () => {
      const tree = busTrees[Math.floor(Math.random() * busTrees.length)];
      const sample = tree.samples[Math.floor(Math.random() * tree.samples.length)];
      const msg: BusMessage = {
        id: seq.current++,
        time: clock(),
        topic: sample.topic,
        payload: JSON.stringify(sample.payload()),
        retained: sample.topic.endsWith('/status'),
        qos: sample.topic.includes('decision') || sample.topic.includes('events') ? 1 : 0,
      };
      setCounts((c) => ({ ...c, [tree.id]: (c[tree.id] ?? 0) + 1 }));
      if (!pausedRef.current) setMessages((m) => [msg, ...m].slice(0, MAX));
      timer = window.setTimeout(tick, 280 + Math.random() * 700);
    };
    timer = window.setTimeout(tick, 200);
    return () => window.clearTimeout(timer);
  }, []);

  return { messages, counts };
}
